import { useCallback, useMemo } from 'react';

import { manageFunnelId } from '../utils';

import { ADD_ON_SUBSCRIPTION_FUNNEL_STARTED_EVENT } from './constants';

import { useLocation } from 'react-router';
import snakecaseKeys from 'snakecase-keys';

import type {
  TrackAddonSubscriptionFunnelStartedPayload,
  UseTrackAddonSubscriptionFunnelReturn,
} from '.';

export const FUNNEL_ID_SESSION_STORAGE = 'addon_subscription_funnel_id';

/**
 * @deprecated once we update `@dashboard/library` to v2.36.0+ we should delete this code
 */
export function useTrackAddonSubscriptionFunnel(
  /**
   * Function to track events. We typically use track function from useDashboardExtensionContext
   * @example
   * ```ts
   * const { track } = useDashboardExtensionContext();
   * ```
   */
  track: (eventName: string, payload: Record<string, unknown>) => void
): UseTrackAddonSubscriptionFunnelReturn {
  const location = useLocation();

  const { setAndReturnNewFunnelId } = manageFunnelId(FUNNEL_ID_SESSION_STORAGE);

  const trackAddonSubscriptionFunnelStarted = useCallback(
    (payload: TrackAddonSubscriptionFunnelStartedPayload) => {
      track(
        ADD_ON_SUBSCRIPTION_FUNNEL_STARTED_EVENT,
        snakecaseKeys({
          ...payload,
          funnelId: setAndReturnNewFunnelId(),
          pagePath: location.pathname,
        })
      );
    },
    [location.pathname, setAndReturnNewFunnelId, track]
  );

  const useTrackAddonSubscriptionFunnelReturn = useMemo(
    () => ({
      trackAddonSubscriptionFunnelStarted,
    }),
    [trackAddonSubscriptionFunnelStarted]
  );

  return useTrackAddonSubscriptionFunnelReturn;
}
